import React, { useContext } from 'react';
import { PPMFormContext } from '../index';
import Accordion from '../accessoryComponents/Accordion';
import DateSelector from '../accessoryComponents/DateSelector';
import MultipleChoiceInput from '../accessoryComponents/MultipleChoiceInput';
import PlainTextInput from '../accessoryComponents/PlainTextInput';
import { InputTypeEnum, PPMFormSectionsEnum } from '../types';
import { PPM_FORM_SECTION_HEADINGS } from '../constants';
import { FIELDS } from './fields';
import PlainFile from '../accessoryComponents/PlainFile';

const Trim = () => {
  const {
    getFieldValueFromStore,
    onChangeRadio,
    onChangeDay,
    onChangeText,
    onFileChange,
  } = useContext(PPMFormContext);

  return (
    <Accordion
      header={PPM_FORM_SECTION_HEADINGS[PPMFormSectionsEnum.TRIM]}
      section={PPMFormSectionsEnum.TRIM}
    >
      {FIELDS.map(field => {
        switch (field.inputType) {
          case InputTypeEnum.MULTIPLE_RADIO:
            if (field.options) {
              return (
                <MultipleChoiceInput
                  key={field.id}
                  field={field.id}
                  label={field.label}
                  options={field.options}
                  value={getFieldValueFromStore(field.id)}
                  onChangeRadio={onChangeRadio}
                  section={PPMFormSectionsEnum.TRIM}
                />
              );
            }
            return (
              <PlainTextInput
                key={field.id}
                id={field.id}
                label={field.label}
                value={getFieldValueFromStore(field.id)}
                onChangeText={onChangeText}
                section={PPMFormSectionsEnum.TRIM}
              />
            );

          case InputTypeEnum.PLAIN_TEXT:
            return (
              <PlainTextInput
                key={field.id}
                id={field.id}
                label={field.label}
                value={getFieldValueFromStore(field.id)}
                onChangeText={onChangeText}
                section={PPMFormSectionsEnum.TRIM}
              />
            );

          case InputTypeEnum.DATE:
            return (
              <DateSelector
                key={field.id}
                field={field.id}
                label={field.label}
                value={getFieldValueFromStore(field.id)}
                onChangeDay={onChangeDay}
                section={PPMFormSectionsEnum.TRIM}
              />
            );

          case InputTypeEnum.PLAIN_FILE:
            return (
              <PlainFile
                key={field.id}
                id={field.id}
                section={PPMFormSectionsEnum.TRIM}
                onFileChange={onFileChange}
                label={field.label}
                getFieldValueFromStore={getFieldValueFromStore}
              />
            );

          default:
            return (
              <PlainTextInput
                key={field.id}
                id={field.id}
                label={field.label}
                value={getFieldValueFromStore(field.id)}
                onChangeText={onChangeText}
                section={PPMFormSectionsEnum.TRIM}
              />
            );
        }
      })}
    </Accordion>
  );
};

export default Trim;
